
function SdGridFilterColController($scope, TranslationService, $filter, $rootScope) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.options = [];

    ctrl.isEmpty = function (value) {
        if (value == null) {
            return true;
        } else {
            return false;
        }
    };

    ctrl.loadOptions = function () {
        var display = ctrl.index;
        for (var i = 0; i < ctrl.grid.length; i++) {

            if (ctrl.grid[i][display] == '')
                ctrl.grid[i][display] = null;

            var item = {
                Value: ctrl.grid[i][display],
                IsChecked: false
            };
            ctrl.options.push(item);
        }
        ctrl.nextOptions();
    };

    ctrl.resetPages = function () {
        ctrl.loadedOptions = [];
        ctrl.numLoaded = 0;
    };

    ctrl.nextOptions = function () {
        if (ctrl.busy) {
            ctrl.infiniteScroll = false;
            return;
        }
        if (ctrl.options) {
            var loadNum = ctrl.numLoaded + ctrl.optionSize;
            if (loadNum > ctrl.options.length) {
                loadNum = ctrl.options.length;
            }
            if (ctrl.numLoaded < loadNum) {
                ctrl.busy = true;
                for (var i = ctrl.numLoaded; i < loadNum; i++) {
                    var item = ctrl.options[i];
                    ctrl.loadedOptions.push(item);
                    ctrl.numLoaded++;
                }
                ctrl.busy = false;
            }
        }
        ctrl.infiniteScroll = false;
    };

    ctrl.dateOptions = [];

    if (ctrl.col.dataType == 'date') {
        var display = ctrl.index;
        for (var i = 0; i < ctrl.grid.length; i++) {
            var item = {
                Value: ctrl.grid[i][display],
                IsChecked: false
            };
            ctrl.dateOptions.push(item);
        }
        ctrl.years = [];
    }

    ctrl.loadedOptions = [];
    ctrl.numLoaded = 0;
    ctrl.optionSize = 1000;
    ctrl.busy = false;

    //var filterScroll = document.getElementById('filter-scroll');

    //document.addEventListener('scroll', (e) => {
    //    if (filterScroll == e.target) {
    //        if (filterScroll.scrollTop > filterScroll.scrollHeight - 1500 && !ctrl.busy) {
    //            ctrl.infiniteScroll = true;
    //            ctrl.nextOptions();
    //        }
    //    }
    //}, true);

    ctrl.changeSearch = function () {
        if (ctrl.search.length > 0) {
            ctrl.loadedOptions = ctrl.options.filter(function (option) {
                return (option.Value.toLowerCase().includes(ctrl.search.toLowerCase()));
            });
        } else {
            ctrl.resetPages();
            ctrl.nextOptions();
        }
    };

    ctrl.checkLoading = function () {
        if (ctrl.isOpen)
            ctrl.loadOptions();
    }

    ctrl.toggled = function () {
        if (!ctrl.col.options) {
            ctrl.onLoadOptions({
                column: ctrl.col
            });
        }
    };
   
    ctrl.selectSort = function (col, sortType) {
        ctrl.col.sortType = sortType;
        if (col) {
            ctrl.onSelectSort({
                column: ctrl.col
            });
            event.stopPropagation();
            ctrl.isOpen = false;
        }
        $rootScope.$broadcast('sort_filter', col);
    };

    ctrl.stopPropagation = function (event) {
        console.log('stropPropagation');
        if (event) {
            event.stopPropagation();
        }
    };

    ctrl.selectOption = function (option) {
        if (option === 0 || option) {
            option.IsChecked = !option.IsChecked;      
            if (!option.IsChecked) {
                ctrl.allSelected = false;
                for (var i = ctrl.col.filterOptions.length - 1; i > -1; i--) {
                    if (ctrl.col.filterOptions[i].Value === option.Value) {
                        ctrl.col.filterOptions.splice(i, 1);
                    }
                }
            } else {
                ctrl.col.filterOptions.push(option);
            }
        }
    };

    ctrl.toggleAll = function () {

        ctrl.allToggled = !ctrl.allToggled;

        ctrl.col.filterOptions = [];

        for (var i = 0; i < ctrl.options.length; i++) {
            ctrl.options[i].IsChecked = ctrl.allToggled;

            if (ctrl.allToggled) {
                ctrl.col.filterOptions.push(ctrl.options[i]);
            }
        }

    };

    ctrl.selectState = function () {
        if (ctrl.col.filterOptions) {
            for (var i = 0; i < ctrl.options.length; i++) {
                if (ctrl.col.filterOptions.length == 0) {
                    return 'none';
                } else if (ctrl.col.filterOptions.length < ctrl.options.length) {
                    return 'partial';
                } else {
                    return 'all';
                }
            }
        }
    };

    ctrl.hasFilters = function (col) {
        if (col.filterOptions) {
            if (col.filterOptions.length > 0 && ctrl.applied)
                return true;
        }
        return false;
    };

    ctrl.ok = function () {
        var filterOptions;
        filterOptions = $filter('unique')(ctrl.col.filterOptions, 'Value');
        ctrl.col.filterOptions = filterOptions;

        if (ctrl.col.dataType == 'date') {

            var years = ctrl.years;
            ctrl.col.filterOptions = [];

            for (var i = 0; i < years.length; i++) {
                for (var j = 0; j < years[i].months.length; j++) {
                    for (var k = 0; k < years[i].months[j].days.length; k++) {
                        if (years[i].months[j].days[k].isChecked == true) {
                            var value = {
                                Value: new Date(years[i].Value, years[i].months[j].Value, years[i].months[j].days[k].Value),
                                dataType: 'date'
                            };
                            ctrl.col.filterOptions.push(value)
                        }
                    }
                }
            }
        }

        ctrl.applied = true;
        ctrl.onSelectOption({
            column: ctrl.col
        });
        event.stopPropagation();
        ctrl.isOpen = false;
    };

    ctrl.cancel = function () {
        ctrl.resetPages();
        ctrl.nextOptions();
        ctrl.col.included = false;
        ctrl.isOpen = false;
    };

    ctrl.remove = function () {
        if (ctrl.col.dataType == 'date') {
            ctrl.cleanAllDates();
        }
        ctrl.resetPages();
        ctrl.nextOptions();
        for (var i = 0; i < ctrl.options.length; i++) {
            ctrl.options[i].IsChecked = false;
        }
        ctrl.col.filterOptions = [];
        ctrl.ok();
    };

    ctrl.cleanAllDates = function () {
        var years = ctrl.years;

        for (var i = 0; i < years.length; i++) {
            for (var j = 0; j < years[i].months.length; j++) {
                for (var k = 0; k < years[i].months[j].days.length; k++) {
                    years[i].months[j].days[k].isChecked = false;
                }
            }
        }

        ctrl.years = years;
    };

    $scope.$on('delete_filter', function (event, filter) {
        if (filter[0].name == ctrl.col.name) {
            ctrl.remove();
        }
    });

    $scope.$on('sort_filter', function (event, col) {
        if( col != ctrl.col) {
            ctrl.col.sortType = '';
        }
    });

}

SdGridFilterColController.$inject = ['$scope', 'TranslationService', '$filter', '$rootScope'];

seedWebApp.component('sdGridFilterCol', {
    controller: SdGridFilterColController,
    bindings: {
        grid: '=',
        col: '=',
        isLoading: '=',
        index: '<',
        onSelectOption: '&',
        onSelectSort: '&',
        onLoadOptions: '&',
    },
    templateUrl: '/SPA/Components/grid/sd-grid-filter-col.html'
});